<template>
  <div class="Agence">
    <h2 class="subtitle">Informations de l'agence</h2>
    <div v-if="form">
      <violet-bar>Général</violet-bar>
      <div class="squarebox">
        <label for="" class="label is-small">Coordonnées</label>
        <div class="field">
          <label for="" class="label is-small"
            >Adresse
            <input
              type="text"
              class="input is-small"
              v-model="form.coords.address"
          /></label>
        </div>
        <div class="field">
          <label for="" class="label is-small"
            >Téléphone
            <input
              type="text"
              class="input is-small"
              v-model="form.coords.phone"
          /></label>
        </div>
        <div class="field">
          <label for="" class="label is-small">Présentation de l'agence</label>
          <textarea
            v-model="form.presentation"
            name=""
            id=""
            cols="30"
            rows="10"
            class="textarea is-small  is-small"
          ></textarea>
        </div>
      </div>
      <violet-bar>Équipe complète</violet-bar>
      <div class="squarebox">
        <table class="table is-striped is-fullwidth">
          <tr v-for="(person, index) in form.workers">
            <td>
              <label class="label is-small"
                >Nom <input class="input is-small" v-model="person.name"
              /></label>
            </td>
            <td>
              <label class="label is-small"
                >Poste <input class="input is-small" v-model="person.poste"
              /></label>
            </td>
            <td>
              <label class="label is-small"
                >Diplôme <input class="input is-small" v-model="person.diploma"
              /></label>
            </td>
            <td>
              <span
                class="delete is-small"
                @click="form.workers.splice(index, 1)"
                style="margin-top: 24px;"
              ></span>
            </td>
          </tr>
        </table>

        <button class="button is-light" @click="addPerson">
          Ajouter un(e) équipier(e)
        </button>
      </div>
      <violet-bar>Curriculum vitae</violet-bar>
      <div class="squarebox">
        <div class="columns is-multiline">
          <div class="column is-half" v-for="person in form.handlers">
            <div class="squarebox">
              <div class="field">
                <label for="" class="label is-small"
                  >Nom :<input
                    type="text"
                    class="input is-small"
                    v-model="person.name"
                /></label>
              </div>
              <div class="field">
                <label for="" class="label is-small">Photo : </label>
                <picture-input
                  :item="person.picture"
                  @update="person.picture = $event.id"
                ></picture-input>
              </div>
              <label for="" class="label is-small"
                >CV :
                <div>
                  <table class="table is-small striped">
                    <tr v-for="(line, i) in person.cv">
                      <td>
                        <label for="" class="label is-small"
                          >Date/période :<input
                            type="text"
                            class="input is-small"
                            v-model="line.date"
                        /></label>
                      </td>
                      <td>
                        <label for="" class="label is-small"
                          >Contenu :<input
                            type="text"
                            class="input is-small"
                            v-model="line.text"
                        /></label>
                      </td>
                      <td>
                        <label for="" class="label is-small"
                        >Ville :<input
                          type="text"
                          class="input is-small"
                          v-model="line.city"
                        /></label>
                      </td>
                      <td>
                        <label for="" class="label is-small"
                        >Pays :<input
                          type="text"
                          class="input is-small"
                          v-model="line.country"
                        /></label>
                      </td>
                      <td>
                        <span
                          @click="person.cv.splice(i, 1)"
                          class="delete is-small"
                          style="margin-top: 24px;"
                        ></span>
                      </td>
                    </tr>
                  </table>

                  <button
                    @click="addLineToCv(person)"
                    class="button is-small"
                    style="margin-top: 1em;"
                  >
                    Ajouter une ligne
                  </button>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <violet-bar>Publications, Expositions et Conférences</violet-bar>
      <div class="squarebox">
        <table class="table is-small is-striped is-hoverable">
          <tr v-for="(line, index) in form.cv">
            <td>
              <div class="field">
                <label class="label is-small">Type </label>
                <div class="select is-small">
                  <select name="" id="" v-model="line.type">
                    <option value="Publication">Publication</option>
                    <option value="Exposition">Exposition</option>
                    <option value="Conférence">Conférence</option>
                  </select>
                </div>
              </div>

              <label class="label is-small"
                >Origine
                <input class="input is-small" v-model="line.description"
              /></label>
            </td>
            <td>
              <div class="field">
                <label class="label is-small"
                  >Projets
                  <kv-suggestor-multiple
                    :hide_plus="true"
                    @update="line.projects = $event"
                    :items="line.projects"
                    :type="'projects'"
                  ></kv-suggestor-multiple>
                </label>
              </div>
              <div class="field">
                <label for="" class="label is-small">Titre (facultatif)</label>
                <input type="text" class="input is-small" v-model="line.title">
              </div>
              <div class="field">
                <label for="" class="label is-small">Url (facultatif)</label>
                <input type="text" class="input is-small" v-model="line.url" />
              </div>
            </td>
            <td>
              <div class="field">
                <label class="label is-small"
                  >Ville <input class="input is-small" v-model="line.city"
                /></label>
              </div>

              <div class="field">
                <label class="label is-small"
                  >Pays <input class="input is-small" v-model="line.country"
                /></label>
              </div>
            </td>
            <td>
              <label class="label is-small"
                >Date <input class="input is-small" v-model="line.date"
              /></label>
            </td>
            <td>
              <span
                class="delete is-small"
                @click="cv.splice(index, 1)"
                style="margin-top: 24px;"
              ></span>
            </td>
          </tr>
        </table>

        <button class="button is-light" @click="addLineToAgenceCv">
          Ajouter une ligne
        </button>
      </div>
      <violet-bar>Moyens matériels</violet-bar>
      <div class="squarebox">
        <div class="squarebox" v-for="(group, index) in form.hardware">
          <div class="field">
            <label for="" class="label is-small"
              >Nom du groupe :
              <input type="text" class="input is-small" v-model="group.name"
            /></label>
          </div>
          <div class="field">
            <label for="" class="label is-small"
              >Complément d'information :
              <input type="text" class="input is-small" v-model="group.remark"
            /></label>
          </div>
          <label for="" class="label is-small">Objets :</label>
          <div class="squarebox">
            <table class="table is-striped is-fullwidth">
              <tr v-for="(thingy, jdex) in group.items">
                <td>
                  <label for="" class="label is-small"
                    >Désignation :
                    <input
                      type="text"
                      class="input is-small"
                      v-model="thingy.text"
                  /></label>
                </td>
                <td>
                  <label for="" class="label is-small"
                    >Quantité :
                    <input
                      type="text"
                      class="input is-small"
                      v-model="thingy.quantity"
                  /></label>
                </td>
                <td>
                  <span
                    class="delete is-small"
                    style="margin-top: 24px;"
                    @click="group.items.splice(jdex, 1)"
                  ></span>
                </td>
              </tr>
            </table>

            <button class="button" @click="addItemToGroup(group)">
              Ajouter un objet
            </button>
          </div>
          <div class="buttons">
            <button class="button" @click="addGroupToHardware">
              Ajouter un groupe
            </button>
            <button
              class="button is-danger"
              @click="form.hardware.splice(index, 1)"
            >
              Supprimer ce groupe
            </button>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="button is-info" @click="save">Enregistrer</button>
        <button class="button is-danger" @click="reset">
          Remettre à zéro le formulaire
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VioletBar from "../Projects/VioletBar";
import { types } from "../../store/actions/misc";
import PictureInput from "../../components/Form/PictureInput";
import KvSuggestorMultiple from "../../components/Form/KvSuggestorMultiple";

const defaultLine = () => ({ date: "1999", text: "", city: "", country: ""});
const defaultCv = () => [defaultLine()];
const defaultAgenceCvLine = () => ({
  type: "Publication",
  description: "",
  projects: [],
  city: "",
  title: "",
  url: "",
  country: "",
  date: 2010
});
const defaultWorker = () => ({
  name: "Archibald Tecte",
  poste: "Architecte",
  diploma: "Architecte DE"
});

const defaultHardwareItem = () => ({
  text: "",
  quantity: ""
});

const defaultHardwareGroup = () => ({
  name: "",
  remark: "",
  items: [defaultHardwareItem(), defaultHardwareItem()]
});

const defaultForm = () => ({
  presentation: "",
  coords: {
    address: "",
    phone: ""
  },
  workers: [defaultWorker(), defaultWorker()],
  handlers: [
    {
      name: "",
      picture: null,
      cv: defaultCv()
    },
    {
      name: "",
      picture: null,
      cv: defaultCv()
    }
  ],
  cv: [defaultAgenceCvLine(), defaultAgenceCvLine(), defaultAgenceCvLine()],
  hardware: [defaultHardwareGroup(), defaultHardwareGroup()]
});

const has_urls_in_publications = form => {
  if (form.cv.length === 0) return true;
  return typeof form.cv[0].url !== "undefined";
};

const has_titles_in_publications = form => {
  if (form.cv.length === 0) return true;
  return typeof form.cv[0].title !== "undefined";
};

const add_urls_to_publications = form => {
  return {
    ...form,
    cv: form.cv.map(p => ({ ...p, url: "" }))
  };
};

const add_titles_to_publications = form => {
  return {
    ...form,
    cv: form.cv.map(p => ({ ...p, title: "" }))
  };
};

const remap_form = form => {
  let f = form;
  if (!has_urls_in_publications(form)) {
    f = add_urls_to_publications(form);
  }
  if (!has_titles_in_publications(form)) {
    f = add_titles_to_publications(form);
  }
  return f;
};

export default {
  name: "Agence",
  components: { KvSuggestorMultiple, PictureInput, VioletBar },
  data() {
    return {
      form: null
    };
  },
  methods: {
    async fetch() {
      try {
        this.$set(
          this,
          "form",
          remap_form(await this.$store.dispatch(types.GET_AGENCE))
        );
      } catch (e) {
        this.$set(this, "form", defaultForm());
      }
    },
    async save() {
      await this.$store.dispatch(types.SET_AGENCE, this.form);
      await this.fetch();
    },
    async reset() {
      this.$set(this, "form", defaultForm());
    },
    addLineToCv(dude) {
      dude.cv.push(defaultLine());
    },
    addLineToAgenceCv() {
      this.form.cv.push(defaultAgenceCvLine());
    },
    addItemToGroup(group) {
      group.items.push(defaultHardwareItem());
    },
    addGroupToHardware() {
      this.form.hardware.push(defaultHardwareGroup());
    },
    addPerson() {
      this.form.workers.push(defaultWorker());
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style lang="scss">
.Agence {
}
</style>
